<template>
  <a class="contacts-item-link" :class="{ 'contact-page': isContactPage }" :href="href">
    <component :is="`icon-${type}`" />
  </a>
</template>

<script>
import iconTel from "@/views/my-contacts/icons/tel.vue";
import iconSms from "@/views/my-contacts/icons/sms.vue";
import iconEmail from "@/views/my-contacts/icons/email.vue";
import iconWhatsapp from "@/views/my-contacts/icons/whatsapp.vue";

export default {
  data() {
    return {
      test: false,
    };
  },

  computed: {
    isContactPage() {
      return this.$route.name === "donor-my-contact";
    },

    href() {
      if (this.type === "sms") {
        const numbers = Array.isArray(this.data) ? this.data.join(",") : this.data;
        const body = this.body ? encodeURIComponent(this.body) : "";
        if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) {
          // iOS/macOS
          let url = `sms://open?addresses=${numbers}/`;
          if (body) url += `&body=${body}`;
          return url;
        } else {
          // Android and others
          let url = `sms:${numbers}`;
          if (body) url += `?body=${body}`;
          return url;
        }
      }
      const _ = {
        tel: `tel:${this.formattedTarget}`,
        email: `mailto:${this.formattedTarget}`,
        whatsapp: `https://wa.me/${this.formattedTarget}`,
      };
      return _[this.type];
    },

    formattedTarget() {
      if (Array.isArray(this.data)) {
        return this.data?.join(",");
      }

      return this.data;
    },
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    data: {
      type: [Array, String],
      required: true,
    },
    body: {
      type: String,
      required: false,
      default: "",
    },
  },

  name: "contact-list-item-link",

  components: {
    "icon-tel": iconTel,
    "icon-sms": iconSms,
    "icon-email": iconEmail,
    "icon-whatsapp": iconWhatsapp,
  },
};
</script>

<style lang="scss" scoped>
.contacts-item-link {
  @apply tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-[var(--my-text-color)] tw-bg-[var(--my-white-soft)] tw-transition-colors;

  &:hover {
    color: var(--my-primary);
  }

  &.contact-page {
    @apply tw-text-[var(--my-primary)];

    svg {
      @apply md:tw-w-[26px] md:tw-h-[26px];
    }
  }
}
</style>
